import { Attr, HasMany, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class Sector extends ApplicationRecord {
  static jsonapiType = "sectors";

  @Attr() name: string;

  @HasMany() subSectors: Sector[];
}

export default Sector;
